// ADD POLYFILS
import '@/utils/polyfils';

// EXTERNAL DEPENDENCIES ///////////////////////////////////////////////////////
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import BootstrapVue from 'bootstrap-vue';
import Toaster from 'v-toaster';
import VeeValidate from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import VueTouch from 'vue-touch';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Vue2Filters from 'vue2-filters';

// INTERNAL DEPENDENCIES ///////////////////////////////////////////////////////
import router from '@/router';
import store from '@/store';
import App from '@/App';


// ADD ALL VUE FILTERS
import '@/filters';
import Hammer from './../node_modules/hammerjs';
import './directives';

delete Hammer.defaults.cssProps.userSelect;
Vue.prototype.$EventBus = new Vue();

// VUE CONFIG //////////////////////////////////////////////////////////////////
sync(store, router);
Vue.use(BootstrapVue);
Vue.use(VueTouch);
Vue.use(Vue2Filters);
Vue.use(Toaster, { timeout: 5000 });

// VEE VALIDATE ////////////////////////////////////////////////////////////////
const veeConfig = { events: 'blur' };
Vue.use(VeeValidate, veeConfig);

Vue.config.productionTip = false;

// ADD STYLE ///////////////////////////////////////////////////////////////////
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap-vue/dist/bootstrap-vue.css');
require('font-awesome/scss/font-awesome.scss');
require('v-toaster/dist/v-toaster.css');
require('./styles/style.sass');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  router,
  template: '<App />',
});

Vue.component('icon', Icon);
Vue.component('datepicker', Datepicker);

// ADD SENTRY /////////////////////////////////////////////////////////////////
/* eslint-disable */
if ( process.env.SENTRY ) {
    console.log('==> lajt-online.pl')
    Raven
        .config('https://ded98f033ecb4374b769b0532985b356@sentry.io/228676')
        .addPlugin(RavenVue, Vue)
        .install();
}



// WEBPACK FOOTER //
// ./src/main.js